import { render, staticRenderFns } from "./ProductTypeChart.vue?vue&type=template&id=5619873d&"
import script from "./ProductTypeChart.vue?vue&type=script&lang=js&"
export * from "./ProductTypeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports